// extracted by mini-css-extract-plugin
export default {"badgeGreen":"styles_badgeGreen__Z9v-R","badgeRed":"styles_badgeRed__7W9Tg","selectedRow":"styles_selectedRow__W2GwD"};